export const languages = [
  { name: 'Español', code: 'es-ES' },
  { name: 'Inglés', code: 'en-EN' },
  { name: 'Catalán', code: 'ca-ES' },
  { name: 'Gallego', code: 'ga-ES' },
  { name: 'Eusquera', code: 'eu-ES' },
]